module.exports = __webpack_public_path__ + "static/media/sponcer_FIT.c734edaf.jpg";